import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import { contains } from 'ramda';

// Redux
import { connect } from 'react-redux';
import { setMetadata } from '../../../../actions/metadata/metadataActions';
import { hideBackButton, setHeaderTitle, showBackButton } from '../../../../actions/header/headerActions';
import {
  closeAlertDialog,
  closeConfirmDialog,
  openConfirmDialog,
  openErrorDialog,
  openSuccessDialog,
} from '../../../../actions/dialog/dialogActions';
import * as AppointmentsTypes from '../../../../actions/appointments/types';
import { hideFullPageLoadingState, showFullPageLoadingState } from '../../../../actions/loadingState/loadingStateActions';
import {
  confirm,
  cancel,
  email,
  getAppointmentMessageRecipients,
  getDefaultEmailRecipient,
  getPastAppointments,
  getUpcomingAppointments,
  sendAppointmentMessage,
} from '../../../../actions/appointments/appointmentsActions';

// Main Layout Components
import Layout from '../../../Layout';
import ActionsPanel from '../../../ActionsPanel';
import ContentPanel from '../../../ContentPanel';
import PastAppointmentsContainer from '../PastAppointments';
import UpcomingAppointmentsContainer from '../UpcomingAppointments';
import SchedulingContainer from '../Scheduling';
import Waitlist from '../Waitlist';
import SingleActionCard from '../../../SingleActionCard/SingleActionCard';

// Page styles
import cx from 'classnames';
import s from './LandingPage.css';


export class LandingPage extends Component {
  // There are router level props here that are omitted as they are not used
  static propTypes = {
    isCollapsed: bool,
    appointments: object,
    authenticatedPreferences: object,
    confirm: func,
    cancel: func,
    closeAlertDialog: func,
    closeConfirmDialog: func,
    email: func,
    getAppointmentMessageRecipients: func,
    getDefaultEmailRecipient: func,
    getPastAppointments: func,
    getUpcomingAppointments: func,
    header: object,
    hideFullPageLoadingState: func,
    hideHeaderBackButton: func,
    loadingState: object,
    openErrorDialog: func,
    openConfirmDialog: func,
    openSuccessDialog: func,
    sendAppointmentMessage: func,
    setHeaderTitle: func,
    setMetadata: func,
    showFullPageLoadingState: func,
    showHeaderBackButton: func,
  };

  static defaultProps = {
    isCollapsed: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      showActionsPanel: false,
      showScheduling: false,
      showWaitlist: false,
      windowWidth: null,
      expanded: null,
    };

    this.isUnmounted = false;
  }

  componentWillMount() {
    this.props.setMetadata({
      activeMenuItemKey: 'appointments',
      pageTitle: 'Appointments',
      pageDescription: 'View your past and upcoming appointments',
    });

    this.props.setHeaderTitle('Appointments');

    if (this.props.header.backButton) {
      this.props.hideHeaderBackButton();
    }

    this.setState({
        expanded: !this.props.isCollapsed,
        windowWidth: window.innerWidth,
    });
  }

  componentDidMount() {
      this.props.getDefaultEmailRecipient();
      this.props.getPastAppointments();
      this.props.getAppointmentMessageRecipients();
      this.props.getUpcomingAppointments();
      window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
      this.isUnmounted = true;
      window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps = nextProps => {
    if (!nextProps.header.backButton) {
      if (this.state.showScheduling || this.state.showWaitlist) {
        this.handleSchedulingGoBack();
      }
    }
  };

  handleSchedulingGoBack = () => {
    if (this.state.showScheduling || this.state.showWaitlist) {
      this.setState({
        showScheduling: false,
        showWaitlist: false,
      });
    }
  };

  handleShowActionsPanel = () => this.setState({ showActionsPanel: true });

  // TODO - This needs wired up but we currently not have a strategy for mobile navigation.
  handleHideActionsPanel = () => this.setState({ showActionsPanel: false });

  handleShowScheduling = () => {
    this.setState({
      showScheduling: true,
      showWaitlist: false,
    });

    this.props.showHeaderBackButton();
  };

  handleShowWaitlist = () => {
    this.setState({
      showScheduling: false,
      showWaitlist: true,
    });

    this.props.showHeaderBackButton();
  };

  handleResize = () => {
      if (this.state.windowWidth <= 768) {
          this.setState({
              expanded: !this.state.expanded,
          });
      }

      const windowWidth = this.state.windowWidth;
      const mobileContentPanelOpen = this.state.expanded;
      const isDesktop = (windowWidth >= 768 && mobileContentPanelOpen);

      if (!this.isUnmounted) {
          let updatedState = { windowWidth: window.innerWidth };
          if (isDesktop) {
              updatedState.expanded = !mobileContentPanelOpen;
          }

          this.setState(updatedState);
      }
  };

  isLoadingPastAppointments = loadingState => contains(AppointmentsTypes.GET_PAST_APPOINTMENTS, loadingState.requests);

  isLoadingUpcomingAppointments = loadingState => contains(AppointmentsTypes.GET_UPCOMING_APPOINTMENTS, loadingState.requests);

  renderSchedulingPicker = () => (
    <Layout column>
      <SingleActionCard
        id="ScheduleCard"
        title="Appointment"
        content="Select the button below to request a scheduled appointment today."
        actionLabel="Request Appointment"
        actionCallback={this.handleShowScheduling}
      />
      <SingleActionCard
        id="WaitlistCard"
        title="Waitlist"
        content="Send a request to our waitlist, and we will contact you with your appointment information."
        actionLabel="Request Waitlist"
        actionCallback={this.handleShowWaitlist}
      />
    </Layout>
  );

  renderSchedulingPanel = () => {

    const schedulingEnabled = this.props.authenticatedPreferences.appointmentSchedulingEnabled;
    const waitlistEnabled = this.props.authenticatedPreferences.appointmentWaitlistingEnabled;

    if (!schedulingEnabled && !waitlistEnabled) {
      return;
    }
    if (schedulingEnabled && waitlistEnabled) {
      if (!this.state.showScheduling && !this.state.showWaitlist) {
        return (
          <ActionsPanel className={cx(s.actionsPanel, s.hideForPrint)}>
            { this.renderSchedulingPicker() }
          </ActionsPanel>
        );
      }

      if (this.state.showScheduling) {
        return (
          <ActionsPanel className={cx(s.actionsPanel, s.hideForPrint)}>
            <SchedulingContainer
              authenticatedPreferences={this.props.authenticatedPreferences}
              closeConfirmDialog={this.props.closeConfirmDialog}
              closeAlertDialog={this.props.closeAlertDialog}
              hideFullPageLoadingState={this.props.hideFullPageLoadingState}
              openConfirmDialog={this.props.openConfirmDialog}
              openSuccessDialog={this.props.openSuccessDialog}
              showFullPageLoadingState={this.props.showFullPageLoadingState}
            />
          </ActionsPanel>
        );
      }
      return (
        <ActionsPanel className={cx(s.actionsPanel, s.hideForPrint)}>
          <Waitlist
            closeAlertDialog={this.props.closeAlertDialog}
            openErrorDialog={this.props.openErrorDialog}
            openSuccessDialog={this.props.openSuccessDialog}
          />
        </ActionsPanel>
      );
    }
    if (waitlistEnabled) {
      return (
        <ActionsPanel className={cx(s.actionsPanel, s.hideForPrint)}>
          <Waitlist
            closeAlertDialog={this.props.closeAlertDialog}
            openErrorDialog={this.props.openErrorDialog}
            openSuccessDialog={this.props.openSuccessDialog}
          />
        </ActionsPanel>
      );
    }
    return (
      <ActionsPanel className={cx(s.actionsPanel, s.hideForPrint)}>
        <SchedulingContainer
          authenticatedPreferences={this.props.authenticatedPreferences}
          closeConfirmDialog={this.props.closeConfirmDialog}
          closeAlertDialog={this.props.closeAlertDialog}
          hideFullPageLoadingState={this.props.hideFullPageLoadingState}
          openConfirmDialog={this.props.openConfirmDialog}
          openSuccessDialog={this.props.openSuccessDialog}
          showFullPageLoadingState={this.props.showFullPageLoadingState}
        />
      </ActionsPanel>
    );
  };

  render = () => {
    const isLoadingPastAppointments = this.isLoadingPastAppointments(this.props.loadingState);
    const isLoadingUpcomingAppointments = this.isLoadingUpcomingAppointments(this.props.loadingState);

    const {
      defaultEmailRecipient,
      past,
      possibleMessageRecipients,
      upcoming,
    } = this.props.appointments;

    const mobileContentPanelIsOpen = (this.state.windowWidth <= 768);
    const mobileContentPanelStyle = (mobileContentPanelIsOpen ? s.isActive : '');

    if (mobileContentPanelIsOpen) {
        return (
            <div className={s.component}>
                <ContentPanel className={cx(s.contentPanel, mobileContentPanelStyle)}>
                    {
                        this.renderSchedulingPanel()
                    }
                    <section id="appointmentsContainer" className={s.appointmentsContainer}>
                        <UpcomingAppointmentsContainer
                            authenticatedPreferences={this.props.authenticatedPreferences}
                            confirm={this.props.confirm}
                            cancel={this.props.cancel}
                            closeAlertDialog={this.props.closeAlertDialog}
                            closeConfirmDialog={this.props.closeConfirmDialog}
                            email={this.props.email}
                            defaultEmailRecipient={defaultEmailRecipient}
                            upcomingAppointments={upcoming}
                            possibleMessageRecipients={possibleMessageRecipients}
                            hideFullPageLoadingState={this.props.hideFullPageLoadingState}
                            openConfirmDialog={this.props.openConfirmDialog}
                            sendAppointmentMessage={this.props.sendAppointmentMessage}
                            showFullPageLoadingState={this.props.showFullPageLoadingState}
                            loadingState={isLoadingUpcomingAppointments}
                        />
                        <PastAppointmentsContainer
                            defaultEmailRecipient={defaultEmailRecipient}
                            email={this.props.email}
                            pastAppointments={past}
                            possibleMessageRecipients={possibleMessageRecipients}
                            hideFullPageLoadingState={this.props.hideFullPageLoadingState}
                            sendAppointmentMessage={this.props.sendAppointmentMessage}
                            showFullPageLoadingState={this.props.showFullPageLoadingState}
                            loadingState={isLoadingPastAppointments}
                        />
                    </section>
                </ContentPanel>
            </div>
        );

    } else {
        return (
            <div className={s.component}>
                {
                    this.renderSchedulingPanel()
                }
                <ContentPanel className={cx(s.contentPanel)}>
                    <section id="appointmentsContainer" className={s.appointmentsContainer}>
                        <UpcomingAppointmentsContainer
                            authenticatedPreferences={this.props.authenticatedPreferences}
                            confirm={this.props.confirm}
                            cancel={this.props.cancel}
                            closeAlertDialog={this.props.closeAlertDialog}
                            closeConfirmDialog={this.props.closeConfirmDialog}
                            email={this.props.email}
                            defaultEmailRecipient={defaultEmailRecipient}
                            upcomingAppointments={upcoming}
                            possibleMessageRecipients={possibleMessageRecipients}
                            hideFullPageLoadingState={this.props.hideFullPageLoadingState}
                            openConfirmDialog={this.props.openConfirmDialog}
                            sendAppointmentMessage={this.props.sendAppointmentMessage}
                            showFullPageLoadingState={this.props.showFullPageLoadingState}
                            loadingState={isLoadingUpcomingAppointments}
                        />
                        <PastAppointmentsContainer
                            defaultEmailRecipient={defaultEmailRecipient}
                            email={this.props.email}
                            pastAppointments={past}
                            possibleMessageRecipients={possibleMessageRecipients}
                            hideFullPageLoadingState={this.props.hideFullPageLoadingState}
                            sendAppointmentMessage={this.props.sendAppointmentMessage}
                            showFullPageLoadingState={this.props.showFullPageLoadingState}
                            loadingState={isLoadingPastAppointments}
                        />
                    </section>
                </ContentPanel>
            </div>
        );
    }
  }
}

const mapStateToProps = state => ({
  appointments: state.appointments,
  authenticatedPreferences: state.authenticatedPreferences,
  header: state.header,
  loadingState: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  confirm: (appointment, successCb) => dispatch(confirm(appointment, successCb)),
  cancel: (appointment, successCb) => dispatch(cancel(appointment, successCb)),
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  email: (appointment, successCb, errorCb) => dispatch(email(appointment, successCb, errorCb)),
  getAppointmentMessageRecipients: () => dispatch(getAppointmentMessageRecipients()),
  getDefaultEmailRecipient: () => dispatch(getDefaultEmailRecipient()),
  getPastAppointments: () => dispatch(getPastAppointments()),
  getUpcomingAppointments: () => dispatch(getUpcomingAppointments()),
  hideFullPageLoadingState: () => dispatch(hideFullPageLoadingState()),
  hideHeaderBackButton: () => dispatch(hideBackButton()),
  openConfirmDialog: dialog => dispatch(openConfirmDialog(dialog)),
  openErrorDialog: dialog => dispatch(openErrorDialog(dialog)),
  openSuccessDialog: dialog => dispatch(openSuccessDialog(dialog)),
  sendAppointmentMessage: (messageData, successCb) => dispatch(sendAppointmentMessage(messageData, successCb)),
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
  setMetadata: metadata => dispatch(setMetadata(metadata)),
  showFullPageLoadingState: () => dispatch(showFullPageLoadingState()),
  showHeaderBackButton: () => dispatch(showBackButton()),
});


export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/LandingPage/LandingPage.js